import { usePathname } from 'next/navigation';
import { useWatch } from 'react-hook-form';

import { RESERVATION, WAITPARTY } from 'reservations/booking/types';

// This is only used for mocking the hook
export const useBookingTypesBaseReturnValue = {
  isModify: false,
  isJoin: false,
  isWaitlist: false,
  isReservation: false
};

export const useBookingTypes = () => {
  const pathname = usePathname();
  const isModify = pathname?.includes('/modify');
  const isJoin = pathname?.includes('/join');

  const bookingType = useWatch({
    name: 'bookingType'
  });
  const isWaitlist = bookingType === WAITPARTY;
  const isReservation = bookingType === RESERVATION;
  return { isModify, isJoin, isWaitlist, isReservation };
};
